import styled from 'styled-components';
import { Container } from 'react-bootstrap';
import ActiveNavImage from '../../../images/head-nav-active.png';
import BackgroundImage from '../../../images/flyout-bg.png';

export const MainContainer = styled.div`
  width: 1200px;
  height: 116px;
  margin: auto;
  @media (max-width: 1199px) {
    width: 960px !important;
  }
  @media (max-width: 991px) {
    width: 728px !important;
    height: 200px;
  }
  @media (max-width: 767px) {
    display: none;
  }
  @media print {
    display: none;
  }
`;

export const TopLogoAnchor = styled.a`
`;
export const TopLogoDiv = styled.div`
  position: relative;
  z-index: 99;
  float: left;
  width: 173px;
  margin: -30px 0 0 0;
  @media (max-width: 1199px) {
    width: 150px;
  }
  @media (max-width: 991px) {
    float: none;
    width: 173px;
    padding: 0 0 0 0;
  }
`
export const TopLogo = styled.img`
  width: 173px;
  height: auto;
  @media (max-width: 1199px) {
    width: 150px;
    height: auto;
  }
  @media (max-width: 991px) {
    width: 173px;
    height: auto;
  }
`;

export const TopNav = styled.div`
  float: right;
  width: 1000px;
  height: 65px;
  
  @media (max-width: 1199px) {
    width: 800px;
  }
  @media (max-width: 991px) {
    float: none;
    width: 728px;
    height: 65px;
    margin-bottom: 0;
    margin-left: auto;
    margin-right: auto;
    margin-top: ${(props) =>props.$title === process.env.GATSBY_DOMAIN_URL +'/' ? '20px' : '40px'} !important;
  }
`;
export const ListDiv = styled.li`
  position: relative;
  float: left;
  margin: 0;
  padding: 0;
  list-style: none;
  background: none;
`;

export const HeaderMenu = styled.a`
  display: block;
  height: 65px;
  padding: 11px 18px 0 18px;
  font-family: 'Tungsten-Medium', arial, sans-serif;
  font-size: 22px;
  line-height: 22px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #136b36;
  text-decoration: none;
  background-repeat: no-repeat;
  background-position: center -103px;
  background-size: auto 102px;
  background-image: url(${ActiveNavImage});
  &.hoverEffect {
    background-image: url(${ActiveNavImage});
    background-position: center -57px;
    background-size: auto 102px;
    background-repeat: no-repeat;
    border: none;
    color: #0c4724;
  }
  &.active {
    padding: 5px 18px 0 18px;
    color: #ffe400;
    border-top: 5px solid #178843;
    background-position: center -1px !important;
    @media (max-width: 1199px) {
      padding: 6px 13px 0 13px !important;
    }
    @media (max-width: 991px) {
      padding: 6px 11px 0 11px !important;
    }
  }
  @media (max-width: 1199px) {
    display: block;
    height: 65px;
    padding: 12px 13px 0 13px;
    font-size: 18px;
    line-height: 18px;
    letter-spacing: 0.04em;
  }
  @media (max-width: 991px) {
    padding: 12px 11px 0 11px;
    font-size: 19px;
    line-height: 19px;
    letter-spacing: 0;
  }
`;

export const Layout = styled.div`
  position: absolute;
  box-shadow: 2px 2px 2px rgb(0 0 0 / 10%);
  z-index: 999;
  background: url(${BackgroundImage}) repeat-x bottom left;
  left: 0;
  top: 50px;
  width: 250px !important;
  padding: 0 !important;
  @media (max-width: 991px) {
    margin-top: 15px;
    padding-bottom: 0;
  }
`;

export const InnerLayout = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 20px 0;
`;
export const RightLayout = styled.div`
  float: none;
  width: 100%;
  padding: 0;
`;
export const pStyle = {
  margin: '0 0 30px 0',
  padding: '0',
};

export const Ul = styled.ul`
  margin: 28px 0 0 0;
  padding: 0;
  float: right;
  @media (max-width: 1199px) {
    margin: 28px 0 0 0;
  }
  @media (max-width: 991px) {
    margin-top: 20px !important;
    float: none;
  }
`